import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RDInstanceRequestStatus } from 'src/types/shared';

export type TakeControlDialogState = {
  open: boolean;
  instanceId?: number;
  controllingUserId?: string | null;
};

export type SelectInstallationDialogState = {
  open: boolean;
  instanceId?: number;
  controllingUserId?: string | null;
};

export type PingCache = {
  instanceId: number | string | undefined;
  result: RDInstanceRequestStatus | undefined;
  time: Date | undefined ;
}

export type AppState = {
  takeControlDialog: TakeControlDialogState;
  selectInstallationDialog: SelectInstallationDialogState;
  pingCache: PingCache;
};

const initialState: AppState = {
  takeControlDialog: {
    open: false,
    instanceId: undefined,
    controllingUserId: undefined,
  },
  selectInstallationDialog: {
    open: false,
    instanceId: undefined,
    controllingUserId: undefined,
  },
  pingCache: {
    instanceId: undefined,
    result: undefined,
    time: undefined,
  }
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setTakeControlDialog: (state, { payload }: PayloadAction<TakeControlDialogState>) => {
      state.takeControlDialog = payload;
    },
    // created for cache ping request REFACTOR REMOVE
    // refactor all rdConnect to context
    setPingCache: (state, { payload }: PayloadAction<PingCache>) => {
      state.pingCache = payload;
    },
    setSelectInstallationDialog: (state, { payload }: PayloadAction<SelectInstallationDialogState>) => {
      state.selectInstallationDialog = payload;
    }
  },
});

export const { setTakeControlDialog, setSelectInstallationDialog, setPingCache } = appSlice.actions;

export default appSlice.reducer;
